import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { YoutubeScenario } from 'src/types/domain';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import Learnables from '../../Learnables';
import Card from '../Card';
import * as msgsData from './messages';
import * as S from './styles';

const { msgs, ...localesWithMessages } = msgsData;

const PALETTE = 'blue';

type CommunicateProps = {
  scenario: YoutubeScenario;
};

const Communicate: FC<CommunicateProps> = ({ scenario: { learnables } }) => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const cta = intl.formatMessage(msgs.cta);
  const learnablesLabel = intl.formatMessage(msgs.learnablesLabel);
  const text = intl.formatMessage(targetMsgs.text);
  const title = intl.formatMessage(targetMsgs.title);
  const topic = intl.formatMessage(msgs.topic);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <Card $palette={PALETTE}>
      <S.Topic $palette={PALETTE}>{topic}</S.Topic>
      <S.Title>{title}</S.Title>
      <S.Text>{text}</S.Text>
      <S.MissionCard mode="vertical" mission="guessing-the-plot-of-the-movie" />
      <S.LearnablesLabel>{learnablesLabel}</S.LearnablesLabel>
      <Learnables learnables={learnables} $palette={PALETTE} />

      <S.FixFlexBasis>
        <Button
          analyticsEvent={eventGeneratorClickCta}
          buttonSizeBreakpoint="md"
          buttonType="primary"
          fullWidth="always"
          href={signUpHref}
        >
          {cta}
        </Button>
      </S.FixFlexBasis>
    </Card>
  );
};

export default Communicate;
